function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.75 6.75C10.0637 6.75 12.75 5.40685 12.75 3.75C12.75 2.09315 10.0637 0.75 6.75 0.75C3.43629 0.75 0.75 2.09315 0.75 3.75C0.75 5.40685 3.43629 6.75 6.75 6.75Z",
  stroke: "#1B75BB",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.75 6.75C12.75 8.407 10.064 9.75 6.75 9.75C3.436 9.75 0.75 8.407 0.75 6.75",
  stroke: "#1B75BB",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.75 9.75V3.75",
  stroke: "#1B75BB",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 3.75V18.75C0.75 20.407 3.436 21.75 6.75 21.75C7.50557 21.7512 8.25936 21.6765 9 21.527",
  stroke: "#1B75BB",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 15.75C0.75 17.407 3.436 18.75 6.75 18.75C7.50557 18.7512 8.25936 18.6765 9 18.527",
  stroke: "#1B75BB",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 12.75C0.75 14.407 3.436 15.75 6.75 15.75C7.50557 15.7512 8.25936 15.6765 9 15.527",
  stroke: "#1B75BB",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 9.75C0.75 11.407 3.436 12.75 6.75 12.75C7.50557 12.7512 8.25936 12.6765 9 12.527",
  stroke: "#1B75BB",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M17.25 17.25C20.5637 17.25 23.25 15.9069 23.25 14.25C23.25 12.5931 20.5637 11.25 17.25 11.25C13.9363 11.25 11.25 12.5931 11.25 14.25C11.25 15.9069 13.9363 17.25 17.25 17.25Z",
  stroke: "#1B75BB",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M11.25 14.25V20.25C11.25 21.907 13.936 23.25 17.25 23.25C20.564 23.25 23.25 21.907 23.25 20.25V14.25",
  stroke: "#1B75BB",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M23.25 17.25C23.25 18.907 20.564 20.25 17.25 20.25C13.936 20.25 11.25 18.907 11.25 17.25",
  stroke: "#1B75BB",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCoins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.ef009bc1.svg";
export { ForwardRef as ReactComponent };